import { Component, Input, OnInit } from '@angular/core';
import { Action,Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import {INotification} from '@app/marketplace/core/models/response.model';

@Component({
  selector: 'app-notify-alert',
  templateUrl: './notify-alert.component.html',
  styleUrls: ['./notify-alert.component.css']
})
export class NotifyAlertComponent implements OnInit {
  @Input() Type:  number=0; //info=0,warning=1,danger=2,
  @Input() Close:  Action;
  @Input() Message: Observable<string>;
  @Input() Notification: Observable<INotification>;
  constructor(private store: Store<any>) {}
  ngOnInit(): void {}
  public closeAlert=() => this.store.dispatch(this.Close);
}
